import React from 'react'

import './inputtext.scss'

const InputText = (props) => {
    let { htmlId, label, onChange, errors, password } = props
    return (
        <>
            <div className="input">
                <input type={ password ? 'password' : 'text' } className={`form-control ${ errors  ? 'is-invalid' : ''}`} id={htmlId} onChange={onChange} required pattern="\S+.*" />
                <label htmlFor={htmlId} className="form-label">{label}</label>
                { errors ? <div className="text-danger invalid-feedback" >{ errors }</div> : '' }
            </div>
        </>
    )
}

export default InputText
